module.exports = __webpack_public_path__ + "static/media/SostenibilitàSistemica_ASSETS-Fish_18.fca5e5fd.png";